import createFormArregators from './createFormArregators';
export default createFormArregators;
